/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GenerationEffortAdvancedModel } from './GenerationEffortAdvancedModel';
import type { GenerationEffortOption } from './GenerationEffortOption';
export type GenerationEffortOptions = {
  show_selector: boolean;
  default_effort: GenerationEffortOptions.default_effort;
  options: Array<GenerationEffortOption>;
  advanced_models: Array<GenerationEffortAdvancedModel>;
};
export namespace GenerationEffortOptions {
  export enum default_effort {
    FASTEST = 'fastest',
    STANDARD = 'standard',
    BALANCED = 'balanced',
    HIGH = 'high',
    MAXIMUM = 'maximum',
  }
}

